import { VALIDATION_STATES } from '../../../core/const/fields.js';

export default {
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
      default: '<span class="colored">Browse</span> a file',
    },
    errorMessage: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    changeable: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      required: true,
    },
    accept: {
      type: String,
    },
    maxSize: {
      type: Number,
      default: 2048,
    },
    percentUploaded: {
      type: Number,
      default: 0,
    },
    isUploading: {
      type: Boolean,
      default: false,
    },
    fileName: {
      type: String,
    },
  },
  computed: {
    isValid() {
      return this.validationState === VALIDATION_STATES.valid;
    },
    isError() {
      return this.validationState === VALIDATION_STATES.error;
    },
  },
  methods: {
    onChangeHandler(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return this.onChange(null);
      }
      const file = files[0];
      return this.onChange(file);
    },
  },
};
